/**
 * AuthCallback – simple redirect page (PKCE flow removed with Supabase).
 *
 * JWT-based auth doesn't require a callback page, but the route is kept so
 * any bookmarked /auth/callback links redirect gracefully to the home page.
 */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  IconSpinner,
} from '../components/icons';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <IconSpinner className="h-10 w-10 animate-spin text-primary-600 mx-auto mb-4" />
        <p className="text-gray-600 text-sm font-medium">Redirecting…</p>
      </div>
    </div>
  );
}
